import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import { URL } from '../../utils/constants/general';
import { useStyles } from './styles';
import Button from '../../components/Button';
import Link from '../../components/Link';

const ErrorPage = props => {
	const { t } = useTranslation();
	const classes = useStyles();
	const history = useHistory();
	const message = props.message || 'error';

	function generateDescription(descriptionStr) {
		const description = descriptionStr.split('^communityForum^');

		return [
			description[0],
			<Link key={description[0]} href={URL.COMMUNITY_FORUM}>
				{t('general.communityForum')}
			</Link>,
			description[1]
		];
	}

	return (
		<Grid container direction="column" alignItems="center" className={classes.container}>
			<Grid item>
				<ErrorOutlineIcon className={classes.icon} />
			</Grid>

			<Grid item className={classes.title}>
				<Typography variant="h4">{t('pages.error.messages.' + message + '.title')}</Typography>
			</Grid>

			<Grid item className={classes.description}>
				<Typography variant="body1">
					{generateDescription(t('pages.error.messages.' + message + '.description'))}
				</Typography>
			</Grid>

			<Grid item>
				{message === 'error' && (
					<Button
						color="secondary"
						variant="outlined"
						onClick={() => {
							history.goBack();
						}}
						className={classes.backButton}>
						{t('pages.error.buttons.tryAgain')}
					</Button>
				)}

				<Button
					color="primary"
					variant="contained"
					onClick={() => {
						history.replace('/');
					}}>
					{t('pages.error.buttons.homepage')}
				</Button>
			</Grid>
		</Grid>
	);
};

ErrorPage.propTypes = {
	message: PropTypes.oneOf(['error', 'pageNotFound'])
};

export default ErrorPage;
